import { Filter } from "@api/models/HttpClientModels";

export default class FoodSideDishFilter extends Filter {
    foodIds?: string;
    sideDishIds?: string;
    isDefault?: boolean;
}